import { Button } from '@tempmee/react';
import { CenteredSpinner } from '~/commonComponents';
import { MODAL_OVERLAY_Z_INDEX } from '~/constants/layout';
import React from 'react';
import { useSelector } from 'react-redux';
import { useCancelJobMutation } from '~/domain/Jobs';
import { Colors } from '../themes/colors';
import '../themes/confirm_hyg.scss';
import '../themes/global.scss';
import { Box, Text } from '~/commonComponents';

export default function CancelledJob({ closePopup }) {
  const { mutate: cancelJob, isPending } = useCancelJobMutation();
  const job = useSelector((state) => state.job.job);

  return (
    <div
      style={{
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        top: 0,
        zIndex: MODAL_OVERLAY_Z_INDEX,
        alignItems: 'center',
        justifyContent: 'center',
        display: 'flex',
      }}
    >
      <div
        style={{
          backgroundColor: Colors.white,
          alignContent: 'center',
          justifyContent: 'center',
          maxWidth: 700,
          minWidth: 450,
          width: '30%',
          borderRadius: 8,
          display: 'flex',
          flexDirection: 'column',
          marginBottom: 50,
          boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.3)',
          shadowColor: Colors.neutral_400,
          shadowOpacity: 0.3,
          shadowOffset: {
            height: 3,
            width: 0,
          },
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            padding: 20,
          }}
        >
          <p
            className="global_font f-dark"
            style={{
              textAlign: 'center',
              fontWeight: 'bold',
              fontSize: 20,
            }}
          >
            Cancel {job?.isOnsiteInterview ? 'Onsite Interview' : 'Shift'}
          </p>
          <Text color={Colors.neutral_500} marginInline={30} textAlign="center">
            {job?.isOnsiteInterview ? (
              <>
                Are you sure you want to cancel this onsite interview on{' '}
                <strong>{job?.local_date}</strong>? Please note: This interview will not be
                available to the community anymore.
              </>
            ) : (
              <>
                Are you sure you want to cancel this shift on <strong>{job?.local_date}</strong>?
                Please note: This shift will not be available to the community anymore.
              </>
            )}
          </Text>
          <div style={{ width: 400, marginTop: 25 }}>
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                margin: '10px 0px',
              }}
            >
              <Text bold color={Colors.neutral_500} fontSize={18}>
                {job?.isOnsiteInterview ? 'Interview Charge' : 'Shift Charge'}:
              </Text>
              <p
                className="global_font"
                style={{ margin: 0, color: Colors.neutral_600, fontSize: 18 }}
              >
                ${job.total.toFixed(2)}
              </p>
            </div>
            <div className="line_400" />
            {job.cancellation_fee !== 0 && (
              <>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    margin: '15px 0px',
                  }}
                >
                  <p
                    className="global_font bold_font"
                    style={{ margin: 0, color: Colors.error_500 }}
                  >
                    Cancellation Fee:
                  </p>
                  <p
                    className="global_font"
                    style={{ margin: 0, color: Colors.neutral_600, fontSize: 18 }}
                  >
                    - ${job.cancellation_fee?.toFixed(2) || '0'}
                  </p>
                </div>
                <div className="line_400" />
              </>
            )}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                margin: '15px 0px',
              }}
            >
              <Text bold color={Colors.neutral_500} fontSize={18}>
                Total Refund:
              </Text>
              <p
                className="global_font"
                style={{ margin: 0, color: Colors.neutral_600, fontSize: 18 }}
              >
                ${job.total_refund.toFixed(2)}
              </p>
            </div>
            <div className="line_400" />
            <Box marginBottom={25} marginTop={20}>
              <Text color={Colors.neutral_500} textAlign="center">
                Please allow 5-7 business days for funds to post
                {'\n'} to your account.
              </Text>
            </Box>
            {isPending ? (
              <div style={{ marginTop: 25 }}>
                <CenteredSpinner />
              </div>
            ) : (
              <div
                style={{
                  marginTop: 25,
                  marginBottom: 25,
                  display: 'flex',
                  justifyContent: 'center',
                  gap: 20,
                }}
              >
                <Button variant="outlined" size="md" onClick={() => closePopup()}>
                  Go Back
                </Button>

                <Button
                  size="md"
                  onClick={() => cancelJob({ jobId: job.id, redirect: true })}
                >
                  {job?.isOnsiteInterview ? 'Cancel Interview' : 'Cancel Shift'}
                </Button>
              </div>
            )}

            <Box marginBottom={25}>
              <Text color={Colors.neutral_500} textAlign="center">
                For more details about our Cancellation Policy, please refer to our FAQs page.
              </Text>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
}
